module.exports = __webpack_public_path__ + "img/succ.5da5c57c.png";